import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "input-icon form-floating" }
const _hoisted_3 = ["type", "id", "value", "readonly", "maxlength"]

import { ref, PropType, watchEffect } from 'vue';
import ValidationLabel from '@/shared/components/ValidationLabel.vue';
import { generateUUID } from '@/guiide/ts/utilities';


export default /*@__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
    modelValue: {
        type: [String] as PropType<string>,
        default: ""
    },
    description: { type: String, default: "" },
    abbreviatedDescription: { type: String, default: "" },
    optional: { type: Boolean, default: false },
    isReadOnly: { type: Boolean, default: false },
    regex: { type: RegExp, default: null },
    keyPressRegex: { type: RegExp, default: null },
    validateOnChange: { type: Boolean, default: false },
    type: { type: String, default: "text" },
    maxlength: { type: String, default: "" }
},
  emits: ['update:modelValue', 'entered'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const id = generateUUID();
const txtNumberInput = ref(null);
const label = ref(null);
const displayValue = ref(props.modelValue?.toString() ?? '');
const hasFocus = ref(false);

const updateModel = (event: Event) => {
    const value = (event.target as HTMLInputElement).value;

    if (props.validateOnChange) {
        isValidInternal(value);
    }

    emit('update:modelValue', value);
};

watchEffect(() => {
    if (props.modelValue === null) {
        displayValue.value = "";
        return;
    }

    if (hasFocus.value) {
        displayValue.value = props.modelValue.toString();
    } else {
        displayValue.value = props.modelValue.toLocaleString();
    }
});

const onKeyPress = (event: KeyboardEvent) => {
    const keyValue = event.key;
    if (props.keyPressRegex && !keyValue.match(props.keyPressRegex)) {
        event.preventDefault();
    }
};

const isValid = (): boolean => {
    return isValidInternal(props.modelValue);
}

function isValidInternal(valueToValidate: string): boolean {
    if (valueToValidate === "") {
        if (!props.optional) {
            label.value.warn("required");
            return false;
        }
        return true;
    }
    
    if (props.regex && !props.regex.test(valueToValidate)) {
        label.value.warn("invalid");
        return false;
    }

    label.value.hideAnyWarnings();
    return true;
}

const hideAnyWarnings = () => {
    label.value.hideAnyWarnings();
}

function takeFocus() {
    txtNumberInput.value.focus();
}

__expose({ isValid, hideAnyWarnings, takeFocus });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: __props.type,
        ref_key: "txtNumberInput",
        ref: txtNumberInput,
        id: `input-${_unref(id)}`,
        value: displayValue.value,
        readonly: __props.isReadOnly,
        maxlength: __props.maxlength,
        onInput: updateModel,
        onKeypress: onKeyPress,
        onFocus: _cache[0] || (_cache[0] = ($event: any) => (hasFocus.value = true)),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (hasFocus.value = false)),
        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (emit('entered')), ["enter"])),
        class: "form-control"
      }, null, 40, _hoisted_3),
      _createVNode(ValidationLabel, {
        ref_key: "label",
        ref: label,
        elementId: `input-${_unref(id)}`,
        text: __props.description,
        abbreviatedText: __props.abbreviatedDescription
      }, null, 8, ["elementId", "text", "abbreviatedText"])
    ])
  ]))
}
}

})